import PropTypes from 'prop-types'
import classnames from 'classnames'

// State
import { useListingSearchContext } from 'src/context/listingSearch'

// Styles
import {
  PLACE_SEARCHES,
  NO_OP_MORE_BUTTON,
  SAVED_SEARCHES,
} from 'src/constants/listings'

// Components
import { Text, Button } from 'src/Components'
import Chevron from './Chevron'
import { FormattedMessage } from 'react-intl'

import { useSelector } from 'react-redux'
import { selectSavedSearches } from 'src/store/selectors/savedSearches'
import styles from './Result.module.scss'
import { INITIAL_NUM_SAVED_SEARCHES_TO_DISPLAY } from 'src/context/listingSearch/context'

const Result = ({ type, index, result }) => {
  const {
    handleShowMoreSavedSearches,
    handleOnClick,
    handleOnTouchStart,
    selectedIndex,
    handleKeyDown,
  } = useListingSearchContext()

  const savedSearches = useSelector(selectSavedSearches)

  const parseSavedSearch = () => {
    const {
      location: { name: locationName },
    } = result

    return `${locationName}`
  }

  const parseName = () => {
    switch (type) {
      case SAVED_SEARCHES:
        return parseSavedSearch()
      case PLACE_SEARCHES:
        return result.name
      default:
        console.error('Invalid Type Provided')
    }
  }

  const isMoreButton = result.id === NO_OP_MORE_BUTTON
  const focused = index === selectedIndex

  if (isMoreButton && savedSearches?.length) {
    return (
      <Button
        fullWidth
        minimal
        onClick={handleShowMoreSavedSearches}
        aria-selected={focused}
        className={classnames(styles.more, focused && styles.moreFocusedBtn)}
      >
        <FormattedMessage
          id='HomeSearch.savedSearches.more'
          defaultMessage='{numMoreSearchesToShow} More'
          values={{
            numMoreSearchesToShow:
              savedSearches.length - INITIAL_NUM_SAVED_SEARCHES_TO_DISPLAY,
          }}
        />
        <Chevron />
      </Button>
    )
  }

  return (
    <li
      role='option'
      id={result.id}
      aria-selected={focused}
      className={classnames(styles.root, focused && styles.focused)}
      key={result.id}
      onKeyDown={handleKeyDown}
      onClick={() => handleOnClick(type, index)}
      onTouchStart={() => handleOnTouchStart(type, index)}
    >
      <Text
        weight='semibold'
        variant='neutralCool'
        variantCount='800'
        element='span'
      >
        {parseName()}
      </Text>
    </li>
  )
}

Result.propTypes = {
  result: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxPriceCents: PropTypes.number,
    minPriceCents: PropTypes.number,
    minBedroomsCount: PropTypes.number,
    location: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  index: PropTypes.number,
  type: PropTypes.string,
}

export default Result
